import { FC } from 'react'
import styles from './footer-nav.module.scss'
import footerNavList from '@/utils/lists/footer-nav.list'
import FooterNavColumn from './FooterNavColumn'

type FooterNavProps = {}

const FooterNav: FC<FooterNavProps> = ({}) => {
  return (
    <div className={styles.columns}>
      {footerNavList.map((column, i) => (
        <FooterNavColumn
          key={`footer_column_${column.titleI18n}`}
          items={column.items}
          titleI18n={column.titleI18n}
          withoutSchema={column.withoutSchema}
        />
      ))}
    </div>
  )
}

export default FooterNav
